export default __webpack_public_path__ + "static/media/suse.b8d9a9e7.svg";